export default __webpack_public_path__ + "static/media/icon-4.18dfa40a.svg";